export default __webpack_public_path__ + "static/media/Big9Logo.5157fa80.svg";